import React from 'react';
import {
    main,
    aniSzym01,
    aniSzym02,
    aniSzym03,
    aniSzym04,
    aniSzym05,
    aniSzym05a,
    aniSzym06,
    aniSzym07,
    aniSzym08,
    aniSzym08a,
    aniSzym09,
    aniSzym10,
    aniSzym11,
    aniSzym12,
    aniSzym13,
    aniSzym14,
    aniSzym15,
    aniSzym16,
    aniSzym17,
    aniSzym18,
    aniSzym19,
    aniSzym20,
    aniSzym21,
    aniSzym22,
    aniSzym23,
    aniSzym24,
    aniSzym25,
    aniSzym26,
    aniSzym27,
    aniSzym28,
    aniSzym29,
    aniSzym30,
    aniSzym31,
    aniSzym32,
    aniSzym33,
    aniSzym34,
    aniSzym35,
    aniSzym36,
    aniSzym37,
    aniSzym38,
    aniSzym39,
    aniSzym40,
    aniSzym41,
    aniSzym42,
    aniSzym43,
    aniSzym44,
    aniSzym45,
} from '../OurCouplesPics/AniaSzymon';

export const AniaAndSzymon = {
    bgColor: "bgDark",
    title: "Ania i Szymon – czarno-białe wesele w Q Hotelu",
    path: "czarno-biale-wesele-w-q-hotelu",
    minHeight: true,
    seoTitle: "Czarno-białe wesele w Q Hotelu | Czarny Marry agencja ślubna",
    seoText: "Nowoczesna elegancja w czerni i bieli. Ania i Szymon postawili na minimalizm z charakterem, tworząc wyjątkowy zimowy ślub w Q Hotelu.",
    mainPic: {
        src: main
    },
    details: "Nowoczesna elegancja w czerni i bieli. Ania i Szymon postawili na minimalizm z charakterem, tworząc wyjątkowy zimowy ślub w Q Hotelu. Humanistyczna ceremonia, odważne stylizacje i wesele na ich zasadach sprawiły, że ten dzień był pełen emocji i stylu.",
    org: "Agencja Ślubna Czary Marry",
    orgLink: "",
    place: "Q Hotel Wrocław Bielany",
    placeLink: "",
    photo: "Małe Szare Studio",
    photoLink: "",
    decor: "Svala Decor",
    decorLink: "",
    movie: "Black Heart Studio",
    movieLink: "",
    makeup: "Anna Dratwa",
    makeupLink: "",
    date: "11 gru 2025",
    textMain:
        <>
            Od pierwszej rozmowy z Anią i Szymonem czułyśmy, że to będzie wyjątkowy projekt. Ich spokój, wyczucie estetyki i odwaga w podejmowaniu decyzji zapowiadały dzień inny niż wszystkie. Poznali się w zupełnie nieoczekiwany sposób — podczas wspólnej gry online — a ich historia od początku miała w sobie coś filmowego. W lutym, w nowoczesnych wnętrzach Q Hotelu na Bielanach Wrocławskich, zrealizowali swoją wizję czarno-białego, pełnego klasy ślubu.
        </>,
    topPic: { src: aniSzym01 },
    content: [
        {
            headerSmall: 'Stylizacja Pary Młodej – klasyka w nowoczesnym wydaniu',
            headerClassName: "dark",
            text: <><p>Ania od początku wiedziała, że nie chce tradycyjnej sukni. Zamiast niej wybrała biały, perfekcyjnie skrojony kombinezon z peleryną, który w ruchu układał się jak suknia haute couture. Subtelny welon dodał całości odrobiny klasyki, tworząc wyjątkowy balans między elegancją a nowoczesnością.</p>
                <p>Do stylizacji dobrała proste, eleganckie dodatki – geometryczną biżuterię, minimalistyczne buty i biały bukiet o wyrazistym charakterze. Makijaż i fryzura były lekkie i naturalne, dopracowane w każdym detalu, tak by podkreślić jej urodę bez przesady.</p><p>Szymon postawił na look z charakterem – czarny golf i marynarka zamiast klasycznej koszuli. To odważne, ale niezwykle stylowe połączenie idealnie wpisało się w klimat całego dnia. Wspólnie wyglądali jak wyjęci z modowego editorialu, ale bez cienia sztuczności – byli po prostu sobą.</p></>,
            pics: [
                { src: aniSzym02 },
                { src: aniSzym03 },
                { src: aniSzym04 },
                { src: aniSzym05 },
                { src: aniSzym05a },
                { src: aniSzym06 },
                { src: aniSzym07 },
                { src: aniSzym08 },
                { src: aniSzym08a }

            ]
        },
        {
            headerSmall: "Q Hotel – przestrzeń, która miała wszystko",
            headerClassName: "dark",
            text: <><p>Cały dzień Ani i Szymona został zaplanowany w jednym miejscu – w eleganckich wnętrzach Q Hotelu na Bielanach Wrocławskich. To przestrzeń, która pozwoliła połączyć wszystkie elementy dnia w spójną całość – od przygotowań, przez ceremonię, aż po zabawę.</p>
                <p>Para spędziła poranek osobno, chcąc zachować magię pierwszego spotkania. Ania przygotowywała się w towarzystwie bliskich, w lekkiej, radosnej atmosferze, a Szymon w męskim gronie, przy dobrej muzyce i żartach. Pierwszy raz zobaczyli się dopiero podczas <b>first looka</b> – momentu pełnego emocji i wzruszenia, który odbył się w sali, gdzie chwilę później mieli powiedzieć sobie „tak”.</p><p>Q Hotel okazał się miejscem idealnym na każdy element tego dnia. Sala, która na co dzień pełni funkcję konferencyjną, dzięki przemyślanej aranżacji zyskała przytulny, romantyczny klimat. Nawet sesja ślubna odbyła się w hotelowych wnętrzach i na tarasie, co dodało wydarzeniu nowoczesnego, miejskiego charakteru.</p></>,
            pics: [
                { src: aniSzym09 },
                { src: aniSzym10 },
                { src: aniSzym11 },
                { src: aniSzym12 },
                { src: aniSzym13 },
                { src: aniSzym14 },
                { src: aniSzym15 },
                { src: aniSzym16 },
                { src: aniSzym17 },
                { src: aniSzym18 },
                { src: aniSzym19 },
            ]
        },
        {
            headerSmall: "Dekoracje – gra kontrastów, światła i detali",
            headerClassName: "dark",
            text: <><p>Choć motyw czerni i bieli coraz częściej pojawia się na ślubach, aranżacja Ani i Szymona wyróżniała się świeżym podejściem i perfekcyjnym dopracowaniem. Wspólnie z Natalią z <b>Svala Dekor</b> stworzyłyśmy koncepcję, która łączyła elegancję, minimalizm i odrobinę zaskoczenia. Część stołów utrzymana była w bieli ze złotymi akcentami, a część w głębokiej czerni, rozświetlonej światłem świec – ten kontrast dodał aranżacji rytmu i charakteru, zachowując pełną spójność.</p><p>Każdy element został zaplanowany z myślą o całości – od układu stołów po dobór krzeseł. Tam, gdzie dominowała biel, pojawiły się czarne siedziska i złote dodatki, a przy czarnych stołach – białe krzesła Dior, które subtelnie podkreślały motyw przewodni.</p><p>Papeteria, świece i delikatne kwiaty tworzyły elegancką oprawę, a stół Pary Młodej – z czarnym obrusem, złotymi detalami i podwieszaną instalacją florystyczną – był efektownym centrum całej kompozycji. To była przestrzeń, w której każdy detal miał znaczenie.</p></>,
            pics: [
                { src: aniSzym20 },
                { src: aniSzym21 },
                { src: aniSzym22 },
                { src: aniSzym23 },
                { src: aniSzym24 },
                { src: aniSzym25 },
                { src: aniSzym26 },
                { src: aniSzym27 },
            ]
        },
        {
            headerSmall: "Ceremonia humanistyczna – słowa, które mają znaczenie",
            headerClassName: "dark",
            text: <><p>Początkowo Ania i Szymon planowali ślub cywilny, jednak w trakcie przygotowań zrozumieli, że chcą czegoś bardziej osobistego. Postawili na <b>ceremonię humanistyczną</b> – i to był strzał w dziesiątkę.</p><p>Własne przysięgi, opowieść o ich historii poznania i wspólne wspomnienia sprawiły, że ceremonia była nie tylko wzruszająca, ale i niezwykle autentyczna. W tle rozbrzmiewała ich ulubiona muzyka, a w powietrzu czuć było spokój, ciepło i radość.</p><p>To był moment, w którym czas się zatrzymał – wszystko inne przestało mieć znaczenie. Liczyli się tylko oni i słowa, które wypowiadali z serca.</p></>,
            pics: [
                { src: aniSzym28 },
                { src: aniSzym29 },
                { src: aniSzym30 },
                { src: aniSzym31 },
                { src: aniSzym32 },
                { src: aniSzym33 },
                { src: aniSzym34 },
            ]
        },
        {
            headerSmall: "Wesele w rytmie Ani i Szymona",
            headerClassName: "dark",
            text: <><p>Po ceremonii przyszedł czas na świętowanie – dokładnie takie, jak wymarzyli sobie Ania i Szymon. Pierwszy taniec był dopracowany, ale pełen naturalnych emocji. Ciepłe światło, subtelna muzyka i spojrzenia, w których można było przeczytać wszystko – to był moment pełen magii.</p><p>Potem parkiet już nie pustoszał. Ulubione utwory, śmiech, rozmowy i toasty wypełniły salę. Goście delektowali się pysznymi drinkami i zimowym słodkim stołem, a atmosfera była tak ciepła, że nikt nie pamiętał o lutowym chłodzie za oknem. To była noc pełna radości – elegancka, ale pełna luzu, dokładnie jak Para Młoda.</p></>,
            pics: [
                { src: aniSzym35 },
                { src: aniSzym36 },
                { src: aniSzym37 },
                { src: aniSzym38 },
            ]
        },
        {
            headerSmall: "Sesja pełna iskier",
            headerClassName: "dark",
            text: "Sesja ślubna Ani i Szymona odbyła się w przestrzeniach Q Hotelu i na jego tarasie. Miejskie światło, delikatny chłód zimowego dnia i ciepło ich spojrzeń stworzyły zdjęcia pełne energii i emocji. Każde ujęcie oddaje to, co najważniejsze – naturalność, bliskość i ich wyjątkową aurę.",
            pics: [
                { src: aniSzym39 },
                { src: aniSzym40 },
                { src: aniSzym41 },
                { src: aniSzym42 },
                { src: aniSzym43 },
                { src: aniSzym44 },
                { src: aniSzym45 },
            ]
        },
        {
            headerSmall: "Nasza rola",
            headerClassName: "dark",
            text: <><p>Dla nas, jako zespołu <b>Czary Marry</b>, to była realizacja, w której mogliśmy połączyć kreatywność z precyzją. Od koncepcji kolorystyki, przez plan dnia, aż po koordynację – każdy element powstał z myślą o Ani i Szymonie.</p><p>Jesteśmy ogromnie dumne, że mogliśmy współtworzyć ich czarno-białe wesele – eleganckie, ale nie przesadzone; dopracowane, ale pełne emocji; nowoczesne, a jednocześnie ciepłe.</p></>,
        },
    ],
}